/**
 * Die Abschnitte des Bautagesberichts, wie sie beim Speichern heißen. Scheitert das Speichern, nachdem die
 * Maske geschlossen ist, nennt der Hinweis diese Namen (`sende({ labels })`) — sonst stünde dort „geraete".
 */
export function tagebuchTeilLabels(t: (key: string) => string): Record<string, string> {
  return {
    wetter: t('siteDocs.diary.weatherTitle'),
    belegschaft: t('siteDocs.diary.staff'),
    geraete: t('siteDocs.diary.equipment'),
    leistungen: t('siteDocs.diary.work'),
    lieferungen: t('siteDocs.diary.deliveries'),
    behinderungen: t('siteDocs.diary.hindrances'),
    anordnungen: t('siteDocs.diary.orders'),
    vorkommnisse: t('siteDocs.diary.incidents'),
  }
}
